import styled from "styled-components";

export const Style = styled.div`
  .wrap {
    position: relative;
    width: 100vw;
    height: 100vh;
    background: #000;
    display: flex;
    flex-direction: column;
    padding: 0 4%;
  }

  .header {
    width: 100%;
    position: sticky;
    padding-top: 20px;
    top: 0;
    background: #000;
  }

  .backButton {
    width: 32px;
    height: 32px;
  }

  h1 {
    text-align: center;
    margin-top: 6%;
    font-size: 40px;
    font-weight: 700;
  }
  h2 {
    font-size: 32px;
    font-weight: 600;
    line-height: 54px;
    color: #555;
  }
  h4 {
    font-size: 18px;
    font-weight: 400;
    color: #555;
  }

  .listWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 8% 4% 0 4%;
  }

  .listItemWrap {
    display: flex;
    align-items: center;
  }
  .listItem {
    width: 92%;
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding: 6% 15% 6% 8%;
    border-radius: 30px;
    background: #ffffff;

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;

      h4 {
        color: #a7a7a7;
      }
    }

    button.details {
      display: flex;
      align-items: center;
      width: fit-content;
      gap: 8px;
      padding: 10px 20px;
      border-radius: 100px;
      border: 1px solid #4dd2ae;
      font-size: 20px;
      font-weight: 600;
      color: #4dd2ae;
    }
  }
  button.call {
    margin-left: -12%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 100px;
    background: linear-gradient(
      180deg,
      #c2c2c2 5.82%,
      #848484 51.94%,
      #222222 93.84%
    );

    .buttonWrap {
      background: #626262;
      padding: 30px;
      border-radius: 100px;
    }
    img {
      width: 64px;
      height: 64px;
    }
  }
`;
